import { ArrowDown } from "lucide-react";
import { useEffect, useState } from "react";
import { cn } from "~/lib/utils";
import { Language, useLanguageStore } from "~/stores/language-store";

type ScrollMoreHintProps = {
    className?: string;
};

const ScrollMoreHint = ({ className = 'absolute -top-5' }: ScrollMoreHintProps) => {
    const { language } = useLanguageStore();
    const [isAtBottom, setIsAtBottom] = useState(true);

    useEffect(() => {
        const check = () => {
            setIsAtBottom(window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 16);
        };

        check();
        window.addEventListener('scroll', check, { passive: true });
        window.addEventListener('resize', check, { passive: true });
        const resizeObserver = new ResizeObserver(check);
        resizeObserver.observe(document.body);

        return () => {
            window.removeEventListener('scroll', check);
            window.removeEventListener('resize', check);
            resizeObserver.disconnect();
        };
    }, []);

    const handleClick = () => {
        window.scrollBy({ top: window.innerHeight * 0.7, behavior: 'smooth' });
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            aria-label={language === Language.GERMAN ? 'mehr anzeigen' : 'show more'}
            className={cn(
                'left-1/2 -translate-x-1/2 inline-flex items-center justify-center rounded-full bg-white p-2 text-burgundy shadow-[0_2px_8px_rgba(86,28,44,0.2)] transition-opacity duration-200',
                className,
                isAtBottom ? 'opacity-0 pointer-events-none' : 'opacity-100',
            )}
        >
            <ArrowDown className='w-4 h-4' />
        </button>
    );
};

export default ScrollMoreHint;
